import { styled } from "@mui/system";
import { InputLabel } from "@mui/material";


export const CategoryInput = styled(InputLabel)(() => ({
    width: "100%"
}));